import { StopTime } from '@rtls/core/models/convoy/stop-time.model';
import { stopFactory } from '@rtls/core/models/convoy/stop.factory';
import { randomDate, randomNumber } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts/lib';

export const stopTimeFactory = Factory.makeFactory<StopTime>({
	arrivalDate: Factory.each(() => randomDate()),
	arrivalTime: Factory.each(() => randomDate()),
	departureDate: Factory.each(() => randomDate()),
	departureTime: Factory.each(() => randomDate()),
	stopSequence: Factory.each(() => randomNumber()),
	shapeDistanceTraveled: Factory.each(() => randomNumber()),
	stop: Factory.each(() => stopFactory.build()),
});
